/** Translation keys used in the framework */
export const enum FrameworkTextKey {
    BirthDateInvalidErrorMessage = 'BirthDateInvalidErrorMessage',
    Cancel = 'Cancel',
    CharactersLeft = 'CharactersLeft',
    ChargingZeroAmountErrorMessage = 'ChargingZeroAmountErrorMessage',
    ChartEmptyDefaultMessage = 'ChartEmptyDefaultMessage',
    ChartErrorDefaultMessage = 'ChartErrorDefaultMessage',
    ChooseFile = 'ChooseFile',
    ClearFilters = 'ClearFilters',
    Clear = 'Clear',
    ClearSelection = 'ClearSelection',
    Close = 'Close',
    CloseDialog = 'CloseDialog',
    CollapseAccordion = 'CollapseAccordion',
    ConfigureProductDetailsProductImageFileTypeError = 'ConfigureProductDetailsProductImageFileTypeError',
    Contains = 'Contains',
    Custom = 'Custom',
    DataGridColumnSettings = 'DataGridColumnSettings',
    Day = 'Day',
    DayFriday = 'DayFriday',
    DayMonday = 'DayMonday',
    DayPlural = 'DayPlural',
    DaySaturday = 'DaySaturday',
    DayShortFriday = 'DayShortFriday',
    DayShortMonday = 'DayShortMonday',
    DayShortSaturday = 'DayShortSaturday',
    DayShortSunday = 'DayShortSunday',
    DayShortThursday = 'DayShortThursday',
    DayShortTuesday = 'DayShortTuesday',
    DayShortWednesday = 'DayShortWednesday',
    DaySunday = 'DaySunday',
    DayThursday = 'DayThursday',
    DayTuesday = 'DayTuesday',
    DayWednesday = 'DayWednesday',
    Days = 'Days',
    Decrement = 'Decrement',
    ExpandAccordion = 'ExpandAccordion',
    Format = 'Format',
    Increment = 'Increment',
    DeselectAll = 'DeselectAll',
    DialogedDatePickerCancel = 'DialogedDatePickerCancel',
    DropzoneFileLimitOverReachedError = 'DropzoneFileLimitOverReachedError',
    DropzoneFileLimitReached = 'DropzoneFileLimitReached',
    Failed = 'Failed',
    FileSizeLargerThanAllowed = 'FileSizeLargerThanAllowed',
    FilesAreNotSupportedErrorMessage = 'FilesAreNotSupportedErrorMessage',
    FilterBySearch = 'FilterBySearch',
    GeneralCustom = 'GeneralCustom',
    GreaterThan = 'GreaterThan',
    Help = 'Help',
    HideColumn = 'HideColumn',
    Hour = 'Hour',
    Hours = 'Hours',
    InputError = 'InputError',
    InvalidServiceOrderEndErrorMessage = 'InvalidServiceOrderEndErrorMessage',
    InvalidUrlErrorMessage = 'InvalidUrlErrorMessage',
    ItemPlural = 'ItemPlural',
    ItemSingular = 'ItemSingular',
    ItemsSelected = 'ItemsSelected',
    LastMonth = 'LastMonth',
    LastQuarter = 'LastQuarter',
    LastWeek = 'LastWeek',
    LastYear = 'LastYear',
    Loading = 'Loading',
    LoadMore = 'LoadMore',
    MaximumTextLengthErrorMessage = 'MaximumTextLengthErrorMessage',
    MewsLogo = 'MewsLogo',
    Month = 'Month',
    MonthApril = 'MonthApril',
    MonthAugust = 'MonthAugust',
    MonthDecember = 'MonthDecember',
    MonthFebruary = 'MonthFebruary',
    MonthJanuary = 'MonthJanuary',
    MonthJuly = 'MonthJuly',
    MonthJune = 'MonthJune',
    MonthMarch = 'MonthMarch',
    MonthMay = 'MonthMay',
    MonthNovember = 'MonthNovember',
    MonthOctober = 'MonthOctober',
    MonthSeptember = 'MonthSeptember',
    MonthShortApril = 'MonthShortApril',
    MonthShortAugust = 'MonthShortAugust',
    MonthShortDecember = 'MonthShortDecember',
    MonthShortFebruary = 'MonthShortFebruary',
    MonthShortJanuary = 'MonthShortJanuary',
    MonthShortJuly = 'MonthShortJuly',
    MonthShortJune = 'MonthShortJune',
    MonthShortMarch = 'MonthShortMarch',
    MonthShortMay = 'MonthShortMay',
    MonthShortNovember = 'MonthShortNovember',
    MonthShortOctober = 'MonthShortOctober',
    MonthShortSeptember = 'MonthShortSeptember',
    Months = 'Months',
    MultipleFileDropNotAllowedErrorMessage = 'MultipleFileDropNotAllowedErrorMessage',
    NextMonth = 'NextMonth',
    NextQuarter = 'NextQuarter',
    NextWeek = 'NextWeek',
    NextYear = 'NextYear',
    Night = 'Night',
    NightPlural = 'NightPlural',
    NoDataAvailable = 'NoDataAvailable',
    NoItems = 'NoItems',
    NoResultsForSearch = 'NoResultsForSearch',
    NotSelected = 'NotSelected',
    NumberNotGreaterThanOrEqualToErrorMessage = 'NumberNotGreaterThanOrEqualToErrorMessage',
    NumberPickerValidationErrorMessage = 'NumberPickerValidationErrorMessage',
    Of = 'Of',
    Ok = 'Ok',
    Optional = 'Optional',
    Or = 'Or',
    PaginationItems = 'PaginationItems',
    PasswordWeakErrorMessage = 'PasswordWeakErrorMessage',
    PaymentStatePending = 'PaymentStatePending',
    PerDay = 'PerDay',
    PerHour = 'PerHour',
    PerMonth = 'PerMonth',
    PerNight = 'PerNight',
    PreviousMonth = 'PreviousMonth',
    Remove = 'Remove',
    Required = 'Required',
    ResetToDefault = 'ResetToDefault',
    Search = 'Search',
    SelectAll = 'SelectAll',
    SelectDate = 'SelectDate',
    SelectEmptyMessage = 'SelectEmptyMessage',
    SelectedDays = 'SelectedDays',
    SelectedHours = 'SelectedHours',
    SelectedMonths = 'SelectedMonths',
    SelectedNights = 'SelectedNights',
    Show = 'Show',
    ShowAll = 'ShowAll',
    SortAscending = 'SortAscending',
    SortDescending = 'SortDescending',
    TableClearFilters = 'TableClearFilters',
    TableEmptyStatePrimary = 'TableEmptyStatePrimary',
    TableFilterBySearch = 'TableFilterBySearch',
    TableFilterContains = 'TableFilterContains',
    TableFilterGreaterThan = 'TableFilterGreaterThan',
    TableHeaderSearch = 'TableHeaderSearch',
    TablePaginationItemsCount = 'TablePaginationItemsCount',
    TablePaginationShow = 'TablePaginationShow',
    TablePaginationSizeItemsCount = 'TablePaginationSizeItemsCount',
    TableSortAscending = 'TableSortAscending',
    TableSortClear = 'TableSortClear',
    TableSortDescending = 'TableSortDescending',
    ThisMonth = 'ThisMonth',
    ThisQuarter = 'ThisQuarter',
    ThisWeek = 'ThisWeek',
    ThisYear = 'ThisYear',
    Today = 'Today',
    Tomorrow = 'Tomorrow',
    ValidateCVV = 'ValidateCVV',
    ValidateDate = 'ValidateDate',
    ValidateEmail = 'ValidateEmail',
    ValidateFormattedNumber = 'ValidateFormattedNumber',
    ValidateGUID = 'ValidateGUID',
    ValidateNumber = 'ValidateNumber',
    ValidateNumberUpperBound = 'ValidateNumberUpperBound',
    ValidatePasswordContainsLowercaseLetters = 'ValidatePasswordContainsLowercaseLetters',
    ValidatePasswordContainsNumbers = 'ValidatePasswordContainsNumbers',
    ValidatePasswordContainsUppercaseLetters = 'ValidatePasswordContainsUppercaseLetters',
    ValidatePasswordSatifiesMinimumLength = 'ValidatePasswordSatifiesMinimumLength',
    ValidatePasswordSatifiesSpecialCharacters = 'ValidatePasswordSatifiesSpecialCharacters',
    ValidatePaymentCard = 'ValidatePaymentCard',
    ValidatePaymentCardExpiration = 'ValidatePaymentCardExpiration',
    ValidatePaymentCardType = 'ValidatePaymentCardType',
    ValidatePhoneNumber = 'ValidatePhoneNumber',
    ValidatePositiveNumber = 'ValidatePositiveNumber',
    ValidateRequired = 'ValidateRequired',
    ValidateTime = 'ValidateTime',
    Yesterday = 'Yesterday',
}
